"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportPitOperationTypes = void 0;
exports.reportPitOperationTypes = {
    SET_ERROR: 'REPORT PIT OPERATION TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'REPORT PIT OPERATION TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'REPORT PIT OPERATION TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'REPORT PIT OPERATION TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'REPORT PIT OPERATION TYPES ON MUTATION',
    ON_FILTER_CHANGE: 'REPORT PIT OPERATION TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'REPORT PIT OPERATION TYPES ON SAVE DATAITEM',
    ON_CHANGE_DATAITEM: 'REPORT PIT OPERATION TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'REPORT PIT OPERATION TYPES SET SUCCESS MODAL',
    SET_EXPORT_DOCUMENTS: 'REPORT PIT OPERATION TYPES SET EXPORT DOCUMENTS',
    CLEAR_EXPORT_DOCUMENTS: 'REPORT PIT OPERATION TYPES CLEAR EXPORT DOCUMENTS',
};
